import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "mpulse-design-system";

const BackToSignInButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/login");
  };

  return (
    <Button color="secondary" onClick={handleClick}>
      Back to Sign In
    </Button>
  );
};

export default BackToSignInButton;
